import { useTranslation } from 'react-i18next';
import { UserOrdersTable } from './components';
import { ModalWrapper, PortalModal } from '@web/utils/src';
import useOrderAgain from '@/hooks/useOrderAgain';

const OrdersPage = () => {
  const { t } = useTranslation();
  const {
    handleOrderAgain,
    warningModalOpen,
    setWarningModalOpen,
    handleSubmitWarningModal,
    handleCancelWarningModal,
  } = useOrderAgain();

  return (
    <>
      {warningModalOpen && (
        <PortalModal isOpen={warningModalOpen} setIsOpen={setWarningModalOpen}>
          <ModalWrapper
            setIsOpen={setWarningModalOpen}
            submitText={'Nur diesen Artikel bestellen'}
            cancelText={'Zu bestehenden Artikeln hinzufügen'}
            t={t}
            submitHandler={handleSubmitWarningModal}
            cancelHandler={handleCancelWarningModal}
          >
            <p className="py-2-0">
              Sie haben bereits Artikel im Warenkorb
              <br />
              Wollen Sie nur diesen Artikel bestellen oder ihn zu den
              bestehenden Artikeln hinzufügen?
            </p>
          </ModalWrapper>
        </PortalModal>
      )}
      <UserOrdersTable handleOrderAgain={handleOrderAgain} />
    </>
  );
};

export default OrdersPage;
